// extracted by mini-css-extract-plugin
export default {"card":"O5-z"};